/*
 * Категория правила (BM-FE-TZ-002B/002C). Правило — либо нарушение, либо
 * бизнес-метрика; категория решает, во вкладку «Нарушения» или
 * «Бизнес-метрики» попадают его события. Других бизнес-полей у правила нет:
 * ViolationRuleCreateV2 принимает только category (additionalProperties:
 * false), смена категории существующего правила — отдельный
 * PATCH /admin/violation-rules-v2/{id}/category.
 */

export const RULE_CATEGORY_VIOLATION = 'violation';
export const RULE_CATEGORY_BUSINESS = 'business';

export const RULE_CATEGORY_OPTIONS = [
  { value: RULE_CATEGORY_VIOLATION, label: 'Нарушение' },
  { value: RULE_CATEGORY_BUSINESS, label: 'Бизнес-метрика' },
];

/** Правило без category — legacy, по смыслу это нарушение. */
export const ruleCategoryOf = (rule) => (
  rule?.category === RULE_CATEGORY_BUSINESS ? RULE_CATEGORY_BUSINESS : RULE_CATEGORY_VIOLATION
);

export const ruleCategoryLabel = (rule) => (
  ruleCategoryOf(rule) === RULE_CATEGORY_BUSINESS ? 'Бизнес-метрика' : 'Нарушение'
);
